import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './common/about/about.component';
import { ContactComponent } from './common/contact/contact.component';
import { RegisterAsComponent } from './common/register-as/register-as.component';
import { WorkingProgressComponent } from './common/working-progress/working-progress.component';
import { HomeComponent } from './home/home.component';
import { HandleActionComponent } from './modules/handle-action/handle-action.component';
import { HandleEditComponent } from './modules/handle-edit/handle-edit.component';
import { LoginComponent } from './modules/login/login.component';
import { LogoutComponent } from './modules/logout/logout.component';
import { ManagedServiceEditComponent } from './modules/managed-service-edit/managed-service-edit.component';
import { ProfessionalServicesDetailComponent } from './modules/professional-services-detail/professional-services-detail.component';
import { ProfessionalServicesEditComponent } from './modules/professional-services-edit/professional-services-edit.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { ServiceProvidersEditComponent } from './modules/service-providers-edit/service-providers-edit.component';
import { SignUpComponent } from './modules/sign-up/sign-up.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { SearchComponent } from './search/search.component';

const routes: Routes = [

  { path: '', component: HomeComponent },
  { path: 'about_us', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'work_in_progress', component: WorkingProgressComponent },
  { path: 'create_service', component: ProfessionalServicesEditComponent },
  { path: 'search_results', component: SearchResultComponent },
  { path: 'service_detail/:id', component: ProfessionalServicesDetailComponent },
  { path: 'search', component: SearchComponent },
  { path: 'service_provider_edit', component: ServiceProvidersEditComponent },
  { path: 'sign-up', component: SignUpComponent  },
  { path: 'login', component: LoginComponent },
  { path: 'register_as', component: RegisterAsComponent },
  { path: 'create_profiled_service', component: ManagedServiceEditComponent },
  { path: 'profile/:id', component: ProfileComponent },
  { path: 'sign_out', component: LogoutComponent },
  { path: 'edit_service/:id', component: ProfessionalServicesEditComponent },
  { path: 'handle_edit', component: HandleEditComponent },
  { path: 'handle_action/:id', component: HandleEditComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
